<template>
  <div class="setup_step card">
    <h4>Setting up taxes</h4>
    <p>If you are required to charge tax then please detail the percentage required below.</p>
    <div class="activate_tax">
      <span
        class="select_type"
        @click="toggleTax"
      >
        <span
          :class="[
            'temp_radio',
            chargingTax ? 'active' : '',
          ]"
          v-html="chargingTax ? '&check;' : '&nbsp;'"
        />
        <label>Apply tax to purchases</label>
      </span>
    </div>
    <accordion-transition>
      <div
        v-if="chargingTax"
        class="tax_options height_transition"
      >
        <div class="card inner">
          <div class="form-group">
            <label>Tax rate percentage</label>
            <div class="input-group">
              <input
                class="form-control"
                type="number"
                :value="taxConfig.percentage"
                step="0.1"
                min="0.1"
                max="100"
                placeholder="20"
                @change="updateTaxRatePercentage($event.target.value)"
              >
              <div class="input-group-prepend">
                <div class="input-group-text">
                  %
                </div>
              </div>
            </div>
            <small
              v-if="errors['taxConfig.percentage']"
              class="text-danger"
            >
              {{ errors['taxConfig.percentage'] }}
            </small>
          </div>
          <div class="form-group">
            <label>Which countries does this tax rate apply to?</label>
            <custom-multiselect
              v-model="selectedCountries"
              label=""
              mode="tags"
              :options="countries"
              :searchable="true"
            />
            <small
              v-if="errors['taxConfig.countries']"
              class="text-danger"
            >
              {{ errors['taxConfig.countries'] }}
            </small>
          </div>
        </div>
      </div>
    </accordion-transition>
    <button
      class="button"
      :disabled="loading"
      @click="storeTaxConfig"
    >
      <i
        v-if="loading"
        class="fas fa-spin fa-spinner"
      />
      Continue
    </button>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AccordionTransition from "../../../../views/reports/components/global/transitions/AccordionTransition";
import CustomMultiselect from "../../../../views/reports/components/global/forms/CustomMultiselect";

export default {
  components: {
    AccordionTransition,
    CustomMultiselect,
  },
  computed: {
    ...mapGetters('merchantCentreSetupWizard', [
      'taxConfig',
      'chargingTax',
      'countries',
      'errors',
      'loading',
    ]),
    selectedCountries: {
      get() {
        return this.taxConfig.countries;
      },
      set(values) {
        this.updateCountries(values);
      }
    }
  },
  methods: {
    ...mapActions('merchantCentreSetupWizard', [
      'toggleTax',
      'updateTaxRatePercentage',
      'updateCountries',
      'storeTaxConfig',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.activate_tax {
  display: flex;
  justify-content: center;
  margin-bottom: .5rem;
  padding-bottom: .5rem;
}

.card {
  &.inner {
    padding: 1rem;
  }
}

.select_type {
  margin-bottom: 1rem;
  cursor: pointer;
  font-weight: 500;

  label {
    font-size: 1.125rem;
    font-weight: 500;
    cursor: pointer!important;
  }

  .temp_radio {
    display: inline-block;
    text-align: center;
    padding: 2px;
    border: 1px solid #37B2A8;
    cursor: pointer;
    margin-right: 15px;
    width: 25px;
    height: 25px;
    color: white;
    border-radius: 6px;

    &.active {
      background: #37B2A8;
      border: 0;
    }
  }

  &.disabled {
    opacity: 0.4;

    .temp_radio {
      cursor: default;
    }
  }
}

.card {
  &.inner {
    border: 0!important;
    background: #FBFAFA;
    box-shadow: none;
    margin-bottom: 0;

    h3 {
      margin: 0;
    }

    p {
      margin-bottom: 2rem;

      &.text-danger:last-of-type {
        margin-bottom: 0;
      }
    }

    h4 {
      font-size: 1.125rem;
      line-height: 1.625rem;
      font-weight: 500;
    }
  }
}

.tax_options {
  margin-bottom: 1rem;
}

.input-group {
  .input-group-prepend {
    background: #FBFAFA;

    .input-group-text {
      border-top-right-radius: 12px !important;
      border-bottom-right-radius: 12px !important;
      font-weight: 500;
      color: #040707;
      border-right: 1px solid #e6ecf5;
      border-left: 0;
    }
  }
  .form-control {
    border-radius: 12px 0 0 12px;
    border-right: 0;
    margin: 0;
    padding: 0 0 0 0.5rem;
    min-height: 46px;
  }
}

.height_transition {
  transition: height 0.3s ease;
}

.custom_input {
  margin-bottom: 0;
}
</style>
